import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import Seo from "@/components/Seo";
import { Preloader } from "@/components/Preloader";
import { Cursor } from "@/components/Cursor";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Merch } from "@/components/Merch";
import { GraphicWork } from "@/components/GraphicWork";
import { Editorial } from "@/components/Editorial";
import { Aracne } from "@/components/Aracne";
import { Fashion } from "@/components/Fashion";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";

const SEO = {
    title: "Marco Giavazzi — Merch & Graphic Archive",
    siteName: "Marco Giavazzi",
    description:
        "Editorial archive: merch, graphic design and art direction — the BSK Sound capsule, posters and flyers, the Aracne fashion film, and fashion/object work by Marco Giavazzi.",
    image: "/assets/hero-pile.jpg",
    jsonLd: {
        "@context": "https://schema.org",
        "@type": "Person",
        name: "Marco Giavazzi",
        jobTitle: "Graphic and Fashion Designer",
        email: "mailto:marcogiavazzi14@gmail.com",
        sameAs: ["https://instagram.com/marco_giavaz"],
    },
};

const useLenis = () => {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (t) => {
            lenis.raf(t);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
};

const Site = () => (
    <>
        <Nav />
        <main>
            <Hero />
            <Marquee />
            <GraphicWork />
            <Editorial />
            <Aracne />
            <Merch />
            <Fashion />
            <About />
        </main>
        <Contact />
    </>
);

function App() {
    const [ready, setReady] = useState(false);
    const reveal = useCallback(() => setReady(true), [setReady]);
    useLenis();

    return (
        <div className="grain min-h-screen bg-[var(--ink)] text-[var(--bone)]">
            <Seo {...SEO} />
            <Cursor />
            <Preloader src="/assets/hero-pile.jpg" onReveal={reveal} />
            {ready && <Site />}
        </div>
    );
}

export default App;
